import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideLead,
  GuideCallout,
  GuideCard,
  GuideCardGrid,
  GuideBlockList,
} from "../GuideBlocks.js";

const SignsYouLackMentalClaritySection = ({ heading, accentIndex = 3 }) => (
  <GuidePanel sectionId="signs-you-lack-mental-clarity" heading={heading} accentIndex={accentIndex}>
    <GuideLead>
      Mental fog develops gradually. Many people mistake it for stress or fatigue. Common signs include:
    </GuideLead>
    <GuideCardGrid columns={2}>
      <GuideCard iconKey="thinking" title="Mental signs">
        <GuideBlockList
          items={[
            "Constant overthinking",
            "Replaying conversations repeatedly",
            "Difficulty focusing",
            "Racing thoughts",
            "Confusion between facts and assumptions",
          ]}
        />
      </GuideCard>
      <GuideCard iconKey="energy" title="Emotional signs">
        <GuideBlockList
          items={[
            "Feeling overwhelmed",
            "Irritability",
            "Anxiety",
            "Emotional reactivity",
            "Fear of making mistakes",
          ]}
        />
      </GuideCard>
      <GuideCard iconKey="clarity" title="Behavioral signs">
        <GuideBlockList
          items={[
            "Re-reading the same message without replying",
            "Postponing decisions you keep revisiting",
            "Switching tasks without finishing any",
            "Checking notifications without acting on them",
          ]}
        />
      </GuideCard>
      <GuideCard iconKey="communication" title="Communication signs">
        <GuideBlockList
          items={[
            "Know what to say but cannot find the words",
            "Think of the perfect response after the conversation",
            "Stay quiet to avoid conflict",
            "Replay conversations for hours",
            "Feel misunderstood despite valuable ideas",
          ]}
        />
      </GuideCard>
    </GuideCardGrid>
    <GuideCallout>
      Mental clarity helps bridge the gap between deep thinking and clear communication — especially for
      introverts and reflective professionals.
    </GuideCallout>
  </GuidePanel>
);

export default SignsYouLackMentalClaritySection;
